import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProjectGallery() {
  const images = ['https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600&q=80', 'https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?w=600&q=80', 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=600&q=80', 'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=600&q=80', 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600&q=80', 'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=600&q=80'];
  return <section className="py-20 bg-white" data-id="element-323">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-324">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-325">
          <div className="max-w-2xl" data-id="element-326">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-327">
              Our Recent Work
            </h2>
            <div className="w-20 h-1 bg-brand-blue mb-6 rounded-full" data-id="element-328"></div>
            <p className="font-body text-brand-gray text-lg" data-id="element-329">
              Browse our portfolio of recent roofing, siding, and exterior
              projects across Southeast Michigan. Seeing is believing.
            </p>
          </div>
          <Link to="/gallery" className="hidden md:flex items-center gap-2 text-brand-blue font-body font-bold hover:text-brand-blue-dark transition-colors whitespace-nowrap" data-id="element-330">
            View Full Gallery <ArrowRight size={20} data-id="element-331" />
          </Link>
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-332">
          {images.map((src, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="break-inside-avoid rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 group" data-id="element-333">
              <div className="brand-overlay" data-id="element-334">
                <img src={src} alt={`Moceri Project ${index + 1}`} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-335" />
              </div>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-336">
          <Link to="/gallery" className="inline-flex items-center gap-2 bg-brand-gray-dark text-white font-body font-bold py-3 px-8 rounded-lg" data-id="element-337">
            View Full Gallery <ArrowRight size={18} data-id="element-338" />
          </Link>
        </div>
      </div>
    </section>;
}